"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var INITIAL_VISIBLE_COLUMNS = ["name", "tier_movement", "milestone", "xp_earned", "date"];
function useColumns() {
    var initialSortDescriptor = { column: "name", direction: "ascending" };
    var _a = (0, react_1.useState)("all"), visibleColumns = _a[0], setVisibleColumns = _a[1];
    var columns = (0, react_1.useMemo)(function () { return [
        { name: "Track Name", uid: "name", sortable: true },
        { name: "Tier Movement", uid: "tier_movement", sortable: false },
        { name: "Milestone", uid: "milestone", sortable: false },
        { name: "XP Earned", uid: "xp_earned", sortable: true },
        { name: "Date", uid: "date", sortable: true },
    ]; }, []);
    var headerColumns = (0, react_1.useMemo)(function () {
        if (!columns || !columns.length) {
            return [];
        }
        return columns
            .map(function (item) {
            if (item.uid === initialSortDescriptor.column) {
                return __assign(__assign({}, item), { sortDirection: initialSortDescriptor.direction });
            }
            return item;
        })
            .filter(function (column) { return (visibleColumns !== "all" ? Array.from(visibleColumns).includes(column.uid) : column); })
            .map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); });
    }, [columns, visibleColumns, initialSortDescriptor]);
    return (0, react_1.useMemo)(function () { return ({
        columns: columns,
        headerColumns: headerColumns,
        initialSortDescriptor: initialSortDescriptor,
        visibleColumns: visibleColumns,
    }); }, [columns, headerColumns, initialSortDescriptor, visibleColumns]);
}
